import { symbolsName } from "sg-consts";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";

class ExpandedWildSupplement implements DataProcessorSupplement {
    /**
     * Checks to see if a results has a full reel of wilds, and replaced them with a stack instead
     */
    public process(record: Record) {

        if (record && record instanceof SpinRecord) {
            const grid = record.grid;

            if (grid) {
                for (let reel = 0; reel < grid.length; reel++) {
                    let wilds = 0;
                    grid[reel].forEach((symbol) => {
                        if (symbol && symbol === symbolsName.WILD) {
                            wilds++;
                        }
                    });

                    if (wilds > 2) {
                        grid[reel] = grid[reel].map(() => "expanded_" + (reel + 1));
                    }
                }
            }
        }
    }
}

export default new ExpandedWildSupplement();
